import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class urpiInterceptor implements HttpInterceptor {
  
    intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const authReq = req.clone({
            headers: req.headers
              .set('Referrer-Policy', 'no-referrer')
              .set('X-Content-Type-Options', 'nosniff')
              .set('Strict-Transport-Security', 'max-age=63072000; includeSubDomains; preload')
              .set('X-XSS-Protection', '1; mode=block')
              .set('X-Frame-Options', 'DENY')
              .set('Content-Security-Policy', "default-src 'self'")
              .set('Permissions-Policy', 'camera=(), microphone=(), geolocation=()')
              .set('Cross-Origin-Embedder-Policy', 'require-corp')
              .set('Cross-Origin-Resource-Policy', 'same-origin')
              .set('Cross-Origin-Opener-Policy', 'same-origin')
          });


          /* ORIGINAL SIN HEADERS DE SEGURIDAD
          req.clone({
            headers: req.headers
            .set('Referrer-Policy', 'Referrer-Policy')
            .set('X-Content-Type-Options', 'X-Content-Type-Options')
            .set('Strict-Transport-Security', 'Strict-Transport-Security')
            .set('X-XSS-Protection', '1')
            .set('X-Frame-Options', 'X-Frame-Options')
        })
          */
        return next.handle(authReq);
    }
}